function formatShopifyMoney(cents, format = 'amount', locale = 'de-DE') {
  const amount = cents / 100;
  switch (format) {
    case 'amount':
      return amount.toFixed(2).replace('.', ','); // e.g. 19,99
    case 'amount_no_decimals':
      return Math.round(amount).toString();
    case 'amount_with_currency':
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'EUR'
      }).format(amount); 
    default:
      return amount.toString();
  }
}

function custom_addtocart(product,open_drawer,form_element){
  console.log("In function",product)
  fetch(`${routes.cart_add_url}`,{
          method: 'POST',
          headers: { "Accept": "application/json", "Content-Type": "application/json" },
          body: JSON.stringify(product)
    })
    .then(response => response.json())
    .then(response => {           
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally((e) => {
      if(open_drawer){
        const this_cartDrawer = document.querySelector('cart-drawer');
        this_cartDrawer.refresh(true);
      }

      if(form_element){
        const submit_button = form_element.querySelector('[type="submit"]') || null;
        if(submit_button){
          submit_button.classList.remove('loading');
          submit_button.removeAttribute('aria-disabled');
        }
          form_element.querySelector('.loading__spinner').classList.add('hidden');
      }
    });
}


document.addEventListener("DOMContentLoaded", function() {
  
  topBarSlider();
  iconWithTextSlider();
  blogSlider();
  footIcons();

  // collectionsWithTabs();
   collTabsSlider();
  brandLogoSlider();
  serviceSafetySlider();
  testimonialSlider();
  //ourServicesSlider();
  

  // Show the first tab by default
  $('.tabs-stage .tabs-content-wrapper').hide();
  $('.tabs-stage .tabs-content-wrapper:first').show();
  $('.tabs-nav li:first').addClass('tab-active');
  
  // Change tab class and display content
  $('.tabs-nav a').on('click', function(event){
    event.preventDefault();
    $('.tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.tabs-stage .tabs-content-wrapper').hide();
    $($(this).attr('href')).show();
  });
  
   

  $(".faq__title").click(function () {
    if (!$(this).hasClass("active")) {
         $(".faq__title").removeClass("active");
         $(".faq_accordion__content").slideUp();
      
      $(this).addClass("active");
      $(this).next(".faq_accordion__content").slideDown();
    }else{
      
       $(this).toggleClass("active");
      $(this).next(".faq_accordion__content").slideToggle();
    }
  });


});


function topBarSlider() { 
  if(!document.querySelector('.top-bar-wrapper .topBarSlider')) return;
  
  var swiper = new Swiper(".topBarSlider", {    
      slidesPerView: 'auto',
      spaceBetween: 20, 
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,        
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 'auto',
          spaceBetween: 40,
        },
      },
  });    
}


function iconWithTextSlider() { 
  if(!document.querySelector('.icon-with-text-wrapper .iconWithTextSlider')) return;
  
  var swiper = new Swiper(".iconWithTextSlider", {    
      slidesPerView: 'auto',
      spaceBetween: 120, 
      navigation: {
        nextEl: ".icon-next",
        prevEl: ".icon-prev",
      },
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,        
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
  });    
}

function blogSlider() { 
  if(!document.querySelector('.section-featured-blog-wrapper .blogSlider')) return;
  
  var swiper = new Swiper(".blogSlider", {    
      slidesPerView: 3,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,        
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1199: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
  });    
}

function footIcons() { 
  if(!document.querySelector('.check-list-wrapper .footIcons')) return;
  
  var swiper = new Swiper(".footIcons", {    
    slidesPerView: 'auto',
    spaceBetween: 60,     
    // navigation: {
    //   nextEl: ".footButton-next",
    //   prevEl: ".footButton-prev",
    // },
    breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: 1,          
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 0,          
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,          
        },
        1199: {
          slidesPerView: 'auto',
          spaceBetween: 60,          
        }
      },
  });    
}


// function collectionsWithTabs() { 
//   if(!document.querySelector('.collections-with-tabs-wrapper .collectionsWithTabs')) return;
  
//   var swiper = new Swiper(".collectionsWithTabs", {    
//       slidesPerView: 'auto',
//       spaceBetween: 30,
//       pagination: {
//         el: ".swiper-pagination",       
//         clickable: true,
//       },
//       breakpoints: {  
//         10: {
//           slidesPerView: 1,
//           spaceBetween: 20,        
//         },
//         450: {
//           slidesPerView: 1,
//           spaceBetween: 20,
//         },
//         750: {
//           slidesPerView: 2,
//           spaceBetween: 20,
//         },
//         991: {
//           slidesPerView: 3,
//           spaceBetween: 20,
//         },
//         1199: {
//           slidesPerView: 'auto',
//           spaceBetween: 30,
//         },
//       },
//   });    
// }

function collTabsSlider() { 
  if(!document.querySelector('.collections-with-tabs-wrapper .collTabsSlider')) return;  
  var swiper = new Swiper(".collTabsSlider", {          
      spaceBetween: 20,  
      slidesPerView:'auto',
       
  });    
}


function brandLogoSlider() { 
  if(!document.querySelector('.brand-logos-wrapper .brandLogoSlider')) return;  
  var swiper = new Swiper(".brandLogoSlider", {          
      spaceBetween: 0,
      centeredSlides: true,
      speed: 6000,
      autoplay: {
        delay: 1,
      },
      loop: true,
      slidesPerView:'auto',
      allowTouchMove: false,
      disableOnInteraction: true
  });    
}


function serviceSafetySlider() { 
  if(!document.querySelector('.our-service-safety-wrapper .serviceSafetySlider')) return;  
  var swiper = new Swiper(".serviceSafetySlider", {    
      slidesPerView: 4,
      spaceBetween: 40,       
      breakpoints: {  
        10: {          
          slidesPerView: 'auto',
          spaceBetween: 20,
          initialSlide: 1,   
          centeredSlides: true,
          pagination: {
            el: ".swiper-pagination",       
            clickable: true,
          },
        },
        450: {           
          slidesPerView: 'auto',
          spaceBetween: 20,
          initialSlide: 1,   
          centeredSlides: true,
          pagination: {
            el: ".swiper-pagination",       
            clickable: true,
          },
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
  });    
}


function testimonialSlider() { 
  if(!document.querySelector('.testimonials-box-wrapper .testimonialSlider')) return;  
  var swiper = new Swiper(".testimonialSlider", {    
      slidesPerView: 1,
      spaceBetween: 0,     
      navigation: {
        nextEl: ".testi-next",
        prevEl: ".testi-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 0,        
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 0,          
        },
        750: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        991: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        1199: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
  });    
}


// function ourServicesSlider() { 
//   if(!document.querySelector('.our-services-wrapper .ourServicesSlider')) return;  
//   var swiper = new Swiper(".ourServicesSlider", {    
//       slidesPerView: 2,
//       spaceBetween: 0, 
//       breakpoints: {  
//         10: {
//           slidesPerView: 1,
//           spaceBetween: 20,        
//         },
//         450: {
//           slidesPerView: 1,
//           spaceBetween: 20,           
//         },
//         750: {
//           slidesPerView: 1,
//           spaceBetween: 20,
//         },
//         991: {
//           slidesPerView: 1,
//           spaceBetween: 20,
//         },
//         1199: {
//           slidesPerView: 2,
//           spaceBetween: 20,
//         },
//       },
//   });    
// }




if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){
      
        const topBarSliderSection = event.target.closest('.top-bar-wrapper') || null;
        if(topBarSliderSection){
          topBarSlider();
        } 

        const iconWithTextSliderSection = event.target.closest('.icon-with-text-wrapper') || null;
        if(iconWithTextSliderSection){
          iconWithTextSlider();
        } 

        const blogSliderSection = event.target.closest('.section-featured-blog-wrapper') || null;
        if(blogSliderSection){
          blogSlider();
        }

        const footIconsSection = event.target.closest('.check-list-wrapper') || null;
        if(footIconsSection){
          footIcons();
        }

      //    const collectionsWithTabsSection = event.target.closest('.collections-with-tabs-wrapper') || null;
      //   if(collectionsWithTabsSection){
      //     collectionsWithTabs();
      //   } 

      const collTabsSliderSection = event.target.closest('.collections-with-tabs-wrapper') || null;
        if(collTabsSliderStion){
          collTabsSlider();
        } 

      
       const brandLogoSliderSection = event.target.closest('.brand-logos-wrapper') || null;
        if(brandLogoSliderSection){
          brandLogoSlider();
        }

      const serviceSafetySliderSection = event.target.closest('.our-service-safety-wrapper') || null;
        if(serviceSafetySliderSection){
          serviceSafetySlider();
        }

      const testimonialSliderSection = event.target.closest('.testimonials-box-wrapper') || null;
        if(testimonialSliderSection){
          testimonialSlider();
        }


      // const ourServicesSliderSection = event.target.closest('.our-services-wrapper') || null;
      //   if(ourServicesSliderSection){
      //     ourServicesSlider();
      //   }


      
    });
  });
}





// PASSWORD SHOW AND HIDE start

class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END



//mobile faq dropdown toggle
const dropdown = document.querySelector(".active-dropdown-tab");
if(dropdown){
  dropdown.addEventListener("click",function (title) {
    const content = document.querySelector(".faqdrop");  
    if (content.style.display === 'none') {
      content.style.display = 'block'; 
    } else {
      content.style.display = 'none'; 
    }
    });
  document.body.addEventListener("click", function(event) {

  const content = document.querySelector(".faqdrop");


  if (!dropdown.contains(event.target) && !content.contains(event.target)) {
    content.style.display = 'none';
  }
});
}



// Initial tab setup
$('.tabs-stage .tabs-content-wrapper').hide();
$('.tabs-stage .tabs-content-wrapper:first').show();
$('.tabs-nav li:first').addClass('tab-active');

// Tab click logic for desktop
$('.tabs-nav a').on('click', function(event){
  event.preventDefault();
  $('.tabs-nav li').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.tabs-stage .tabs-content-wrapper').hide();
  $($(this).attr('href')).show();
});

// Mobile dropdown tab logic
const titles = document.querySelectorAll(".faq-title"); 
if (titles) {
  titles.forEach((title) => {
    title.addEventListener("click", function (event) {
      const target = event.target.closest('a');
      const dropdown = document.querySelector(".faqdrop");  
      if (dropdown) dropdown.style.display = 'none';

      const click_attr = title.getAttribute("data-faq-title");
      document.querySelectorAll(".tabs-content-wrapper-mobile").forEach((content) => {
        const title_attr = content.getAttribute("data-title");
        content.style.display = (click_attr === title_attr) ? "block" : "none";
      });

      if (target) {
        const activeTab = document.querySelector(".active-dropdown-tab");
        if (activeTab) activeTab.textContent = target.textContent;
      }
    });
  });
}




// Video Pop-up
$(function () {
	$('.popup-modal').magnificPopup({
		type: 'inline',
		preloader: false,
		focus: '#username',
		modal: true
	});
	$(document).on('click', '.popup-modal-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});



    // const seminarInput_main = document.querySelector('input[name="Online-Seminar-date"]') || null;
    // const seminarInput = document.querySelector('input[name="properties[Online-Seminar-date]"]') || null;
  
    // if (seminarInput_main != null && seminarInput!= null) {
    //     seminarInput_main.addEventListener("change", function () {
    //         console.log("New Value:", this.value); // Logs the updated value
    //       seminarInput.value = this.value
    //         // You can update or manipulate the value if needed
    //     });
    // }

  
  
  
  
});

// ---------------read more sj product page-------------------


// Initially, hide all list items after the 5th one
  const listItems = document.querySelectorAll(".product-left-container .product-features ul li");
  const readMoreButton = document.querySelector(".more_info-btn");
if(readMoreButton){
if (listItems.length > 5 ) {
  readMoreButton.style.display = "block";
  for (let i = 5; i < listItems.length; i++) {
    listItems[i].style.display = "none";
  }

  // Toggle visibility of all list items on button click
  readMoreButton.addEventListener("click", function() {
    const isExpanded = readMoreButton.getAttribute("data-expanded") === "true";
    
    if (isExpanded) {
      // Collapse the list, showing only the first 5 items
      for (let i = 5; i < listItems.length; i++) {
        listItems[i].style.display = "none";
      }
      readMoreButton.style.display = "none";
    } else {
      // Expand the list, showing all items
      for (let i = 5; i < listItems.length; i++) {
        listItems[i].style.display = "list-item";
      }
      readMoreButton.style.display = "none";
    }
  })
} else {
   readMoreButton.style.display = "none";
}
}



// const qtyInputs = document.querySelectorAll('.personenanzahl');
// if (qtyInputs.length) {

// qtyInputs.forEach(inputEl => {
//   inputEl.addEventListener('input', function () {
//     const qty = parseInt(this.value || 0);
//     console.log(qty, "qty");
//     if (qty <= 0) return;

//     const wrapper = this.closest('.product__info-wrapper');
//     if (!wrapper) return;
//     console.log(wrapper, "wrapperwrapperwrapperwrapper");

//     const form = wrapper.querySelector('form');
//     if (!form) return;
//     console.log(form, "formformformform");

//     const select = wrapper.querySelector('.product-form__input .select select');
//     const selectedValue = select?.value?.trim() || '';
//     console.log(select, 'selectselectselectselectselect');
//     console.log(selectedValue, 'selectedValueselectedValueselectedValue');

//     if (selectedValue !== 'Online-Seminar') return;

//     const container = form.querySelector('.attendee-fields-container');
//     if (!container) return;

//     container.innerHTML = '';
//     for (let i = 1; i <= qty; i++) {
//       const group = document.createElement('div');
//       group.classList.add('attendee-input-group');
//       group.innerHTML = `
//         <input type="text" name="properties[attendee_name_${i}]" placeholder="Full Name" required>
//         <input type="email" name="properties[attendee_email_${i}]" placeholder="Email Address" required>
//       `;
//       container.appendChild(group);
//     }
//   });
// });
// }


 document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.attendee-fields-container');
 

  if (container) {
    container.addEventListener('input', function(event) {
      const target = event.target;
      if (target.tagName === 'INPUT') {
        target.setAttribute('value', target.value);
      }

      // E-Mail-Validierung: @ prüfen + Duplikate erkennen
      const emailInputs = container.querySelectorAll('input[type="email"]');
      const emailValues = [];
      let emailsValid = true;

      emailInputs.forEach(function(emailInput) {
        const val = emailInput.value.trim().toLowerCase();
        // Bestehende Fehlermeldung entfernen
        const existingError = emailInput.parentElement.querySelector('.email-error');
        if (existingError) existingError.remove();
        emailInput.style.borderColor = '';

        if (val !== '') {
          // Prüfe ob @ vorhanden und sinnvoll platziert
          if (!val.includes('@') || val.indexOf('@') === 0 || val.indexOf('@') === val.length - 1) {
            emailsValid = false;
            emailInput.style.borderColor = '#e74c3c';
            const errorMsg = document.createElement('span');
            errorMsg.className = 'email-error';
            errorMsg.style.cssText = 'color:#e74c3c;font-size:12px;display:block;margin-top:2px;';
            errorMsg.textContent = 'Bitte eine gültige E-Mail-Adresse eingeben (mit @).';
            emailInput.parentElement.appendChild(errorMsg);
          }
          // Prüfe auf Duplikate
          else if (emailValues.includes(val)) {
            emailsValid = false;
            emailInput.style.borderColor = '#e74c3c';
            const errorMsg = document.createElement('span');
            errorMsg.className = 'email-error';
            errorMsg.style.cssText = 'color:#e74c3c;font-size:12px;display:block;margin-top:2px;';
            errorMsg.textContent = 'Diese E-Mail-Adresse wurde bereits verwendet.';
            emailInput.parentElement.appendChild(errorMsg);
          }
          emailValues.push(val);
        }
      });

     const submitButtonn = document.querySelector('.product-form__buttons button');
      // Check if all input fields inside container are filled + emails valid
      const inputs = container.querySelectorAll('input');
      const allFilled = Array.from(inputs).every(input => input.value.trim() !== '');
      if (allFilled && emailsValid) {
        submitButtonn.removeAttribute('data-variant-unavalable');
        submitButtonn.classList.add('newClass'); 
      } else {
        submitButtonn.setAttribute('data-variant-unavalable', '');
        submitButtonn.classList.remove('newClass'); 
      }
    });
  }
});

 const qtyInputs = document.querySelectorAll('.personenanzahl');
         if (qtyInputs.length) {
            qtyInputs.forEach(inputEl => {
              inputEl.addEventListener('input', function () {
                const qty = parseInt(this.value || 0);
                if (qty <= 0) return;
          
                const wrapper = this.closest('.find-closest-element');
                if (!wrapper) return;
          
                const form = wrapper.querySelector('.product-right-container');
                if (!form) return;
          
                // const select = wrapper.querySelector('.product-form__input .select select');
                //     const selectedValue = select?.value?.trim() || '';
                // if (selectedValue !== 'Online-Seminar') return;
          
                const container = form.querySelector('.attendee-fields-container');
                if (!container) return;
          
                // Clear previous fields
                container.innerHTML = '';
          
                // Add new inputs
                for (let i = 1; i <= qty; i++) {
                  const group = document.createElement('div');
                  group.classList.add('attendee-input-group');
                  group.innerHTML = `
                    <input type="text" name="properties[attendee_person_${i}]" placeholder="Vorname Nachname" >
                    <input type="email" name="properties[attendee_person_${i}]" placeholder="E-Mail Adresse" >
                  `;
                  container.appendChild(group);
                }
          
                // ===== ✅ Add logic to check inputs & enable/disable Add to Cart =====
                // const addToCartBtn = wrapper.querySelector('[type="submit"][name="add"]');
                const checkInputsAndToggleButton = () => {
                  const attendeeInputs = container.querySelectorAll('.attendee-input-group input');
                  const allFilled = Array.from(attendeeInputs).every(input => input.value.trim() !== '');
                  // addToCartBtn.disabled = !allFilled;
                };
          
                // Add input listeners to all new inputs
                const newInputs = container.querySelectorAll('.attendee-input-group input');
                newInputs.forEach(input => {
                  input.addEventListener('input', checkInputsAndToggleButton);
                });
          
                // Initially disable Add to Cart until all fields are filled
                checkInputsAndToggleButton();

                  console.log(qty,'qty');
                const pricediv =  form.querySelector('.price-plus');
                if (pricediv) {
                  
               const getprice =  pricediv.getAttribute("data-price-plus");
                  const priceplus = getprice * qty;
                  pricediv.innerHTML = formatShopifyMoney(priceplus, 'amount_with_currency');
                }

              });
            });
          }